export default __webpack_public_path__ + "static/media/user1.4860442e.svg";